import styled, { css } from 'styled-components';
import Link from 'next/link';
import { FlexibleDiv } from '../../../../styled/common';
import { ChipsText } from '../../../ui/Chips/styled';

export const AgencyFilterHeaderContainer = styled(FlexibleDiv)`
  flex-wrap: nowrap;
  width: auto;
  height: 64px;
  padding: 10px 20px;
  margin: 10px -20px;
  overflow-y: hidden;
  overflow-x: auto;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.background.primary};
  -ms-overflow-style: none;
  scrollbar-width: none;
  gap: 10px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const chipsStyles = css`
  padding: 0 15px;

  ${ChipsText} {
    padding-top: 0;
  }
`;

export const ChipLink = styled(Link)`
  text-decoration: none;

  label {
    cursor: pointer;
  }
`;
